import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'


export const app = firebase.initializeApp({
    apiKey: "AIzaSyDO9dILGPDMeJ0rGQm1-06pMf0Ip-h7afA",
    authDomain: "goodcitizen-a906e.firebaseapp.com",
    databaseURL: "https://goodcitizen-a906e.firebaseio.com",
    projectId: "goodcitizen-a906e",
    storageBucket: "goodcitizen-a906e.appspot.com",
    messagingSenderId: "136113019444",
    appId: "1:136113019444:web:aaf3d61ea5a103df4f4861",
    measurementId: "G-L1FME8R56P"
});
export const db = app.firestore();



// var firebaseConfig = {
//     apiKey: "AIzaSyDGoagnH0Vo4Y7SjdN2e7_miOFi5YfFgKU",
//     authDomain: "good-citizen-4fedb.firebaseapp.com",
//     databaseURL: "https://good-citizen-4fedb.firebaseio.com",
//     projectId: "good-citizen-4fedb",
//     storageBucket: "good-citizen-4fedb.appspot.com",
//     messagingSenderId: "378117289529",
//     appId: "1:378117289529:web:5db64269bad88b72017fe8",
//     measurementId: "G-E2D9SHBZ85"
//   };
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);
//   firebase.analytics();